module.exports = __webpack_public_path__ + "static/img/user-menu-4.b95d7e3e.png";